export default __webpack_public_path__ + "static/media/landing.09c35b9f.svg";